<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix" style="text-align: center">
        <span style="font-weight: bold;font-size: 20px;">问题反馈</span>
      </div>
      <div style="width: 500px;margin: 0 auto">
        <el-form ref="feedbackForm" :model="feedbackForm" :rules="rules" label-width="80px" :hide-required-asterisk="true">
          <el-form-item label="问题类型" prop="fenlei">
            <el-select v-model="feedbackForm.fenlei" placeholder="请选择问题类型" style="width: 100%;">
              <el-option label="BUG" value="BUG"></el-option>
              <el-option label="简历验证" value="简历验证"></el-option>
              <el-option label="资源侵权" value="资源侵权"></el-option>
              <el-option label="其他" value="其他"></el-option>
            </el-select>

          </el-form-item>
          <el-form-item label="问题内容" prop="neirong">
            <el-input type="textarea" :rows="10" v-model="feedbackForm.neirong" placeholder="请输入问题内容" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="button-container" type="primary" @click="onSubmit('feedbackForm')">提交</el-button>
            <el-button class="button-container" @click="resetForm('feedbackForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import {addFeedback, sendBarkMessage} from '../../../../request/api'
import Common from '../../../../js/Common'

export default {
  name: 'Feedback',
  data () {
    return {
      feedbackForm: {
        fenlei: '',
        neirong: ''
      },
      rules: {
        fenlei: [
          {required: true, message: '问题类型不可为空', trigger: 'change'}
        ],
        neirong: [
          {required: true, message: '问题内容不能为空', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    onSubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          var barkParams = {'title': '小D的空间——' + this.feedbackForm.fenlei, 'body': this.feedbackForm.neirong, 'group': '小D的空间', 'isArchive': '1', 'icon': Common.barkLogo()}

          sendBarkMessage(barkParams).then(res => {
            // console.log(res)
            if (res.code === '200' && res.message === 'success') {
              // this.$message({
              //   type: 'success',
              //   message: '提交成功'
              // })
              // this.resetForm(form)
            } else {
              this.$message.error(res.message)
            }
          }).catch((error) => {
            // error
            console.log(error)
          })

          var params = {'type': this.feedbackForm.fenlei, 'content': this.feedbackForm.neirong, 'systemos': ''}

          addFeedback(params).then(res => {
            if (res.code === '90') {
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.resetForm(form)
            } else {
              this.$message.error(res.msg)
            }
          }).catch((error) => {
            // error
            console.log(error)
          })
        } else {
          return false
        }
      })
    },
    resetForm (form) {
      this.$refs[form].resetFields()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pc/pages/about/Feedback.vue